<div [formGroup]="matrixRowAddFormGroup" *ngIf="matrixRowAddFormGroup">
    <mat-icon class="font-size-16" *ngIf="isDuplicate" #tooltip="matTooltip" matTooltip="DUPLICATE" [matTooltipPosition]="tooltip_position">
        <a href="javascript:void(0)" (click)="open(joint_id)">file_copy</a>
    </mat-icon>

    <!-- copy join id modal -->
    <ng-template #joint_id let-modal>
        <div class="modal-header">
            <h4 i118n>Duplicate Calculation</h4>
            <a class="close-icon" href="javascript:void()" ngbAutofocus (click)="modal.close('Ok click')"><i class="flaticon2-cross"></i></a>
        </div>
        <div class="modal-body output-lable">
            <div class="row">
                <div class="col-md-3" style="padding: 15px">
                    <mat-label class="font-style">Joint ID Name</mat-label>
                </div>
                <div class="col-md-9">
                    <mat-form-field class="example-full-width custom-text-field">
                        <input type="text" matInput formControlName="jointId" name="jointname" />
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn primary-ebtn" (click)="btnDuplicateMatrixRow()">Ok</button>
            <button type="button" class="btn secondary-ebtn" (click)="modal.close('Ok click')">Cancel</button>
        </div>
    </ng-template>
    <!-- copy join id modal -->
</div>
